import { defineStore } from 'pinia';
import { AxiosAPI } from '@/axios';
import { useMainStore } from './index';

export const useKanbanStore = defineStore('kanban', {
  state: () => ({
    days: {
      Segunda: [],
      Terça: [],
      Quarta: [],
      Quinta: [],
      Sexta: [],
      Sábado: [],
      Domingo: []
    },
    loading: false,
    fetchRequestId: 0
  }),

  actions: {
    async fetchTasks(referenceDate, clearCurrent = false) {
      this.loading = true;
      if (clearCurrent) {
        this.days = {
          Segunda: [],
          Terça: [],
          Quarta: [],
          Quinta: [],
          Sexta: [],
          Sábado: [],
          Domingo: []
        };
      }
      const requestId = ++this.fetchRequestId;
      const mainStore = useMainStore();
      try {
        const resp = await AxiosAPI.get(`/api/tasks?reference_day=${referenceDate}`, {
          headers: { Authorization: `Bearer ${mainStore.accessToken}` }
        });
        if (requestId !== this.fetchRequestId) return;
        this.days = {
          Segunda: resp.data.tasks.monday || [],
          Terça: resp.data.tasks.tuesday || [],
          Quarta: resp.data.tasks.wednesday || [],
          Quinta: resp.data.tasks.thursday || [],
          Sexta: resp.data.tasks.friday || [],
          Sábado: resp.data.tasks.saturday || [],
          Domingo: resp.data.tasks.sunday || []
        };
      } catch (error) {
        console.error('Erro ao buscar tarefas:', error);
      } finally {
        if (requestId === this.fetchRequestId) {
          this.loading = false;
        }
      }
    },

    async updateTask(taskId, payload) {
      const mainStore = useMainStore();
      return await AxiosAPI.put(`/api/tasks/${taskId}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${mainStore.accessToken}`
        }
      });
    },

    async editTaskFormData(taskId, formData) {
      const mainStore = useMainStore();
      return await AxiosAPI.post(`/api/tasks/${taskId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${mainStore.accessToken}`
        }
      });
    },

    async duplicateTask(taskId, payload) {
      const mainStore = useMainStore();
      return await AxiosAPI.post(`/api/tasks/${taskId}/duplicate`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${mainStore.accessToken}`
        }
      });
    },

    async deleteTask(taskId, endpoint = '') {
      const mainStore = useMainStore();
      return await AxiosAPI.delete(`/api/tasks/${taskId}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${mainStore.accessToken}`
        }
      });
    }
  }
});